import React from "react"
import classNames from "classnames"

interface FieldViewBoxProps {
	label: string
	children: React.ReactNode
	className?: string
}

export default function FieldViewBox({label, children, className}: FieldViewBoxProps) {
	return (
		<div className={classNames("textfield", className)}>
			<div className="content">
				<div className="label">
					<span className="label-text">{label}</span>
				</div>
				<div className="value">{children}</div>
			</div>
		</div>
	)
}
